import { TranslateService } from '@ngx-translate/core';
import { IconType } from '@se/cp.common';
import { GridUtilitiesService } from '../../services/grid-utilities.service';
import { EstensaColDef } from '../search-param.model';

export function telemonitoringColumnDefs(
    translate: TranslateService,
    gridUtils: GridUtilitiesService,
): EstensaColDef[] {
    return [
        {
            colId: 'lockColId',
            headerName: '',
            tooltipField: '',
            width: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0' },
            cellRenderer: 'lockUnlockRenderer',
            cellRendererParams: {
                lockedField: 'locked',
                userField: 'lockedUserFullName',
            },
        },
        {
            colId: 'ExamOutOfFlow',
            headerName: '',
            tooltipField: '',
            field: 'patient.isLocalPatient',
            width: 50,
            suppressSizeToFit: true,
            resizable: false,
            lockPosition: true,
            pinned: 'left',
            cellStyle: { padding: '0' },
            cellRenderer: 'boolIconRenderer',
            cellRendererParams: {
                estensa: {
                    iconType: IconType.SeFont,
                    icon: 'icon_flusso_inverso',
                    tooltip: 'PatientDataNotAssociated',
                },
            },
        },
        {
            colId: '0',
            headerName: translate.instant('Patient'),
            headerTooltip: translate.instant('Patient'),
            valueGetter: (e) => {
                const lastName = e.data.patient.lastName ?? '';
                const firstName = e.data.patient.firstName ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            tooltipValueGetter: (e) => {
                const lastName = e.data.patient.lastName ?? '';
                const firstName = e.data.patient.firstName ?? '';
                return `${lastName.toLocaleUpperCase()} ${firstName.toLocaleUpperCase()}`;
            },
            width: 220,
            minWidth: 220,
            suppressSizeToFit: true,
            lockPosition: true,
            pinned: 'left',
            cellStyle: (e) => {
                if (e.data.patient.isCertificating === true) return { 'background-color': 'yellow', color: 'black' };
                if (e.data.patient.isCertificating === false && e.data.patient.isCertified === false)
                    return { 'background-color': 'red' };
                return null;
            },
        },
        {
            colId: '1',
            headerName: translate.instant('TelemonitoringType'),
            headerTooltip: translate.instant('TelemonitoringType'),
            tooltipField: 'exam.description',
            field: 'exam.description',
            width: 150,
            minWidth: 150,
            sort: 'desc',
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '2',
            headerName: translate.instant('EnrolmentStartDate'),
            headerTooltip: translate.instant('EnrolmentStartDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'examinationDate',
            width: 150,
            minWidth: 150,
            sort: 'desc',
            valueFormatter: gridUtils.dateTimeFormatter('examinationDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '3',
            headerName: translate.instant('EnrolmentEndDate'),
            headerTooltip: translate.instant('EnrolmentEndDate'),
            tooltipValueGetter: (p) => p.valueFormatted,
            field: 'approvalDate',
            width: 150,
            minWidth: 150,
            valueFormatter: gridUtils.dateTimeFormatter('approvalDate'),
            comparator: gridUtils.dateComparator,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '4',
            headerName: translate.instant('TaxCode'),
            headerTooltip: translate.instant('TaxCode'),
            tooltipField: 'patient.taxCode',
            field: 'patient.taxCode',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '5',
            headerName: translate.instant('Phone'),
            headerTooltip: translate.instant('Phone'),
            tooltipField: 'patient.phone',
            field: 'patient.phone',
            width: 190,
            minWidth: 190,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '6',
            headerName: translate.instant('Email'),
            headerTooltip: translate.instant('Email'),
            tooltipField: 'patient.email',
            field: 'patient.email',
            width: 220,
            minWidth: 220,
            suppressSizeToFit: false,
            hide: false,
        },
        {
            colId: '7',
            headerName: translate.instant('Notes'),
            headerTooltip: translate.instant('Notes'),
            tooltipField: 'monitoringStatus',
            field: 'monitoringStatus',
            width: 120,
            minWidth: 120,
            suppressSizeToFit: false,
            hide: false,
        },
    ];
}
